export interface IFavorite {
  id: number;
  item_id: number;
  item_type: string;
  wishlist_creator_id?: number;
  wishlist_name?: string;
  wishlist_id?: number;
}

interface IWishlistsState {
  rentals: IFavorite[];
  escapes: IFavorite[];
}

export const initialWishlistsState: IWishlistsState = {
  rentals: [],
  escapes: [],
};

// Action Types
const SET_WISHLISTED_ITEMS = 'wishlists/SET_DATA';

interface ISetWishlistedItemsAction {
  type: typeof SET_WISHLISTED_ITEMS;
  payload: IWishlistsState;
}

type TWishlistsAction = ISetWishlistedItemsAction;

// Action Creators

export const setWishlistedItems = (data: IWishlistsState): ISetWishlistedItemsAction => ({
  type: SET_WISHLISTED_ITEMS,
  payload: data,
});

export default function reducer(
  state = initialWishlistsState,
  action: TWishlistsAction,
): IWishlistsState {
  switch (action.type) {
    case SET_WISHLISTED_ITEMS:
      return {
        ...state,
        rentals: action.payload.rentals,
        escapes: action.payload.escapes,
      };

    default:
      return state;
  }
}
